/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';
import { relative } from 'node:path';

export const storeLocatorGridContainerSX: SxProps = {
	pt:2,
	flexDirection:globalBreak({mobile:'column', desktop:'row'}),
	justifyContent:'flex-start'
};
export const googleMapSx: SxProps = {
	'& .gm-svpc div img': {
    	position: 'relative !important'
	}
}
